const cartHeaderStyles = /*css*/ `
  :host {
    --close-icon-size: var(--cart-drawer-close-icon-size, 24px);
    --close-icon-color: var(--cart-drawer-close-icon-color, #000000);
    --check-icon-size-width: 24px;
    --check-icon-size-height: 24px;
    --error-title-color: var(--cart-drawer-error-title-color, #a80000);
    --error-icon-color: var(--cart-drawer-error-title-color, #a80000);
    --check-icon-color: var(--cart-drawer-title-icon-color, var(--cart-drawer-title-color, #000000));
    --title-bg-color: #ffffff;
    --title-border-color: var(--cart-drawer-title-bd-cl, #d4d4d4);
    --title-font-family: var(--cart-drawer-title-font, inherit);
    --title-font-size: var(--cart-drawer-title-font-size, 1rem);
    --title-text-transform: var(--cart-drawer-title-text-transform, uppercase);
    --title-line-height: var(--cart-drawer-title-line-height, 1.25);
    --title-font-weight: bold;
    --title-letter-spacing: var(--cart-drawer-title-letter-spacing, 0);
    --title-color: var(--cart-drawer-title-color, #000000);
    --message-fg-color: var(--cart-drawer-font-cl, #000000);
    --message-font-family: inherit;
    --message-font-size: var(--cart-drawer-message-font-size, 0.75rem);
    --message-line-height: 1.25;
    --message-alignment: flex-start;
    --message-bg-color: var(--cart-drawer-message-bg, #fafafa);
  }
  .cart-header {
    display: flex;
    flex-direction: row;
    width: calc(100% - 32px);
    align-items: center;
    padding: 12px 16px;
    justify-content: space-between;
    text-transform: var( --title-text-transform);
    background-color: var(--title-bg-color);
    border-bottom: 1px solid var(--title-border-color);
    border-top: var(--cart-drawer-title-border-top, none);
    font-family: var(--title-font-family);
    font-size: var(--title-font-size);
    line-height: var(--title-line-height);
    font-weight: var(--title-font-weight);
    letter-spacing: var(--title-letter-spacing);
    color: var(--title-color);
  }
  .cart-header.error {
    color: var(--error-title-color);
  }
  .cart-header-title {
    display: flex;
    gap: 11px;
    align-items: center;
  }
  .cart-messages {
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    gap: 8px;
    width: calc(100% - 32px);
    justify-content: center;
    color: var(--message-fg-color);
    background-color: var(--message-bg-color);
    font-family: var(--message-font-family);
    font-size: var(--message-font-size);
    line-height: var(--message-line-height);
    align-items: var(--message-alignment);
  }
  .cart-header-title .cart-svg {
    display: block;
  }
  ::slotted(.cart-header__close-button) {
    width: var(--close-icon-size);
    height: var(--close-icon-size);
    fill: var(--close-icon-color);
    cursor: pointer;
  }
  @media (min-width: 1024px) {
    :host {
      --title-font-size: var(--cart-drawer-title-font-size, 0.875rem);
      --title-line-height: var(--cart-drawer-title-line-height, 1.43);
    }
  }
`;

const cartMessagesStyles = /*css*/ `
  :host {
    --message-fg-color: var(--cart-drawer-font-cl, #000000);
    --message-font-family: inherit;
    --message-font-size: var(--cart-drawer-message-font-size, 0.75rem);
    --message-line-height: 1.25;
    --message-alignment: flex-start;
    --message-bg-color: var(--cart-drawer-message-bg, #fafafa);
  }
  .cart-messages {
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    gap: 8px;
    width: calc(100% - 32px);
    justify-content: center;
    color: var(--message-fg-color);
    background-color: var(--message-bg-color);
    font-family: var(--message-font-family);
    font-size: var(--message-font-size);
    line-height: var(--message-line-height);
    align-items: var(--message-alignment);
  }
`;

export { cartHeaderStyles, cartMessagesStyles };
